export default __webpack_public_path__ + "static/media/callNew.2e65d50c.svg";